
/*---------- Open All External Links in New Tab ----------*/

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

/*---------- RAW Theme code edits ----------*/
/*---------- main-cart.liquid line 9 ----------*/
/*---------- From: <a href="{{ routes.all_products_collection_url }}" class="button " aria-label="{{ 'general.continue_shopping' | t }}">{{- 'general.continue_shopping' | t -}}</a> ----------*/
/*---------- To: <a href="https://midlandcomms.com.au/collections/all-products" class="button " aria-label="{{ 'general.continue_shopping' | t }}">{{- 'general.continue_shopping' | t -}}</a> ----------*/